import template from './whatIsSolidayEuroFooter.html';
import controller from './whatIsSolidayEuroFooter.controller';
import './whatIsSolidayEuroFooter.scss';

let whatIsSolidayEuroFooterComponent = {
  restrict: 'E',
  bindings: {
    clickAmplify:'&',
  },
  template,
  controller
};

export default whatIsSolidayEuroFooterComponent;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/components/whatIsSolidaryEuro/whatIsSolidayEuroFooter/whatIsSolidayEuroFooter.component.js